
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/museums/[id]/[slug]",
      function () {
        return require("private-next-pages/museums/[id]/[slug].tsx");
      }
    ]);
  